import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid } from '@material-ui/core';
import { UsuarioProfileDetails, UsuarioProfileSummarized } from './components';
import { isAuthenticated } from '../../helpers/authenticate';
import SnackbarCustom from '../../components/Compartilhados/Snackbar';
import ProgressFullScreen from '../../components/Compartilhados/ProgressFullScreen';
import { ServiceValues } from '../../values/ServiceValues';
import { ServiceAxios } from '../../services/ServiceEW';
import { Values } from '../../values/Values';
import UsuarioListChangePassword from './components/UsuarioProfileChangePassword/UsuarioProfileChangePassword';
import { ValidatorForm } from 'react-material-ui-form-validator';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { apagarImagem, uploadImagem } from '../../services/ImagemService';
import { updateUsuario } from '../../services/UsuarioService';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(4)
  }
}));

const UsuarioProfile = (props, {history}) => {
  const { usuarioLogado, setUsuarioLogado, getUsuarioLogado } = props.params;
  const timeout = ServiceValues.timeout;
  const baseUrl = ServiceValues.base_url_local;
  const api = ServiceAxios(baseUrl, timeout);
  const classes = useStyles();
  const [loading, setLoading] = React.useState(false);
  const [showMessageSnack, setShowMessageSnack] = useState(false);
  const [messageSnack, setMessageSnack] = useState('');
  const [typeSnack, setTypeSnack] = useState('success');
  const [openUsuarioChangePassword, setOpenUsuarioChangePassword] = useState(false);
  const [senhaAtual, setSenhaAtual] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [replicaNovaSenha, setReplicaNovaSenha] = useState('');
  const [mostrarSenhaAtual, setMostrarSenhaAtual] = useState('');
  const [mostrarNovaSenha, setMostrarNovaSenha] = useState('');
  const [mostrarReplicaNovaSenha, setMostrarReplicaNovaSenha] = useState('');
  const [openDialogConfirmation, setOpenDialogConfirmation] = useState(false);



  useEffect(() => {
    function checkAuth() {
      isAuthenticated(history);
    }
    checkAuth();
  }, []);

  useEffect(() => {
    async function serviceGetUsuarioLogado() {
      try{
        const user = JSON.parse(localStorage.getItem('auth'));
        if (user) {
          setLoading(true);
          const dados = await api.get(`usuarios/${user.result.idUsuario}`);
          setLoading(false);
          if(dados && dados.data){
            if (dados.data.isSuccess) {
              if (dados.data.result.length > 0) {
                setUsuarioLogado(dados.data.result[0]);
              } else {
                setLoading(false);
                setTypeSnack('error');
                setMessageSnack('Ocorreu um erro ao obter dados do usuário.');
                setShowMessageSnack(true);
              }
            } else {
              setLoading(false);
              setTypeSnack('error');
              setMessageSnack('Ocorreu um erro ao obter dados do usuário.');
              setShowMessageSnack(true);
            }
          }
          else{
            setLoading(false);
            setTypeSnack('error');
            setMessageSnack(Values.MessageValues.erro_catch);
            setShowMessageSnack(true);
          }
        }
      }
      catch (e) {
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack(Values.MessageValues.erro_catch);
        setShowMessageSnack(true);
      }
    }
    serviceGetUsuarioLogado();
  }, []);

  async function changePassword(senhaAtual, novaSenha, replicaNovaSenha) {
    try{
      setOpenUsuarioChangePassword(false);
      setLoading(true);
      if (novaSenha !== replicaNovaSenha) {
        setTypeSnack('error');
        setMessageSnack('Novas senhas não são iguais. Por favor, verifique e tente novamente.')
        setShowMessageSnack(true);
        setOpenUsuarioChangePassword(true);
      } else {
        let body = {
          senhaAtual: senhaAtual,
          novaSenha: novaSenha
        };
        let updatePassword = await api.put(`usuarios/${usuarioLogado.idUsuario}/update-password`, body);
        if(updatePassword.data.isSuccess){
          setTypeSnack('success');
          setMessageSnack(updatePassword.data.message);
          setShowMessageSnack(true);
          setSenhaAtual('');
          setMostrarSenhaAtual(false);
          setNovaSenha('');
          setMostrarNovaSenha(false);
          setReplicaNovaSenha('');
          setMostrarReplicaNovaSenha(false);
        }
        else{
          setTypeSnack('error');
          setMessageSnack(updatePassword.data.message);
          setShowMessageSnack(true);
          setOpenUsuarioChangePassword(true);
        }

      }
      setLoading(false);

    }
    catch (e) {
      setLoading(false);
      setOpenUsuarioChangePassword(true);
      setTypeSnack('error');
      setMessageSnack(`Ocorreu um erro no processamento da requisição. Contate o suporte! Detalhamento do erro: ${e.toString()}`);
      setShowMessageSnack(true);
    }

  }

  function logout(event) {
    localStorage.removeItem('auth');
    history.push('/sign-in')
  }

  function logoutConfirmation(e) {
    setOpenDialogConfirmation(true);
  }

  function openDialogChangePass() {
    setOpenUsuarioChangePassword(true);
  }

  function closeLogoutConfirmation(e){
    setOpenDialogConfirmation(false);
  }

  async function getUsuario() {
    try{
      const user = JSON.parse(localStorage.getItem('auth'));
      if (user) {
        setLoading(true);
        const dados = await api.get(`usuarios/${user.result.idUsuario}`);
        setLoading(false);
        if(dados && dados.data){
          if (dados.data.isSuccess) {
            if (dados.data.result.length > 0) {
              setUsuarioLogado(dados.data.result[0]);
            } else {
              setLoading(false);
              setTypeSnack('error');
              setMessageSnack('Ocorreu um erro ao obter dados do usuário.');
              setShowMessageSnack(true);
            }
          } else {
            setLoading(false);
            setTypeSnack('error');
            setMessageSnack('Ocorreu um erro ao obter dados do usuário.');
            setShowMessageSnack(true);
          }
        }
        else{
          setLoading(false);
          setTypeSnack('error');
          setMessageSnack(Values.MessageValues.erro_catch);
          setShowMessageSnack(true);
        }
      }
    }
    catch (e) {
      setLoading(false);
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch);
      setShowMessageSnack(true);
    }
  }

  async function chamarServiceUpdateUsuario(usuarioNovo) {
    try {
      setLoading(true);
      const baseUrl = ServiceValues.base_url_local;
      const api = ServiceAxios(baseUrl, timeout);
      usuarioNovo.cpfCnpj = usuarioNovo.cpfCnpj.replace('.', "");
      usuarioNovo.cpfCnpj = usuarioNovo.cpfCnpj.replace('.', "");
      usuarioNovo.cpfCnpj = usuarioNovo.cpfCnpj.replace('-', "");
      const usuario_put = {
        nome: usuarioNovo.nome,
        nomeFantasia: usuarioNovo.nomeFantasia,
        cpfCnpj: usuarioNovo.cpfCnpj,
        sexo: usuarioNovo.sexo,
        dataNascimento: usuarioNovo.dataNascimento,
        enderecos: usuarioNovo.enderecos,
        telefones: usuarioNovo.telefones
      };
      const dados = await api.put(`usuarios/${usuarioLogado.idUsuario}`, usuario_put);
      if (dados.data.isSuccess) {
        setMessageSnack('Perfil atualizado com sucesso.');
        setTypeSnack('success');
        setShowMessageSnack(true);
        await getUsuario();
        setLoading(false);
      } else {
        setMessageSnack(dados.data.message);
        setTypeSnack('error');
        setShowMessageSnack(true);
        setLoading(false);
      }
    } catch (e) {
      setMessageSnack(Values.MessageValues.erro_catch);
      setTypeSnack('error');
      setShowMessageSnack(true);
      setLoading(false);
    }
  }

  async function aoModificarImagemPerfil(e) {
    try {
      if (e.target.files.length > 0) {
        setLoading(true);
        let novaImagem = e.target.files[0];
        const uploado_image = await uploadImagem(novaImagem);
        if (uploado_image.isSuccess) {
          const usuarioPut = {
            idUsuario: usuarioLogado.idUsuario,
            idImagemPerfil: uploado_image.result.idImagem
          };
          const updateUsuarioResponse = await updateUsuario(usuarioPut);
          if (updateUsuarioResponse.isSuccess) {
            setLoading(false);
            usuarioLogado.imagem = uploado_image.result;
            setUsuarioLogado(usuarioLogado);
            setMessageSnack('Imagem de perfil modificada com sucesso.');
            setTypeSnack('success');
            setShowMessageSnack(true);
            getUsuarioLogado();
          }
          else {
            setLoading(false);
            setMessageSnack(updateUsuarioResponse.message);
            setTypeSnack('warning');
            setShowMessageSnack(true);
          }

        }
        else {
          setLoading(false);
          setMessageSnack(uploado_image.message);
          setTypeSnack('warning');
          setShowMessageSnack(true);
        }
      }
    } catch (e) {
      setLoading(false);
      setMessageSnack('Ocorreu um erro no processamento da requisição.');
      setTypeSnack('error');
      setShowMessageSnack(true);
    }

  }

  async function deletarImagemPerfil(e) {
    try {
      e.preventDefault();
      setLoading(true);
      let deleteImagem = await apagarImagem(usuarioLogado.idImagemPerfil);
      if (deleteImagem.isSuccess) {
        setLoading(false);
        setMessageSnack('Imagem removida com sucesso.');
        setTypeSnack('success');
        setShowMessageSnack(true);
        const usuarioPut = {
          idUsuario: usuarioLogado.idUsuario,
          idImagemPerfil: null
        };
        await updateUsuario(usuarioPut);
        getUsuarioLogado();
      }
      else {
        setLoading(false);
        setMessageSnack('Ocorreu um erro no processamento da requisição.');
        setTypeSnack('error');
        setShowMessageSnack(true);
      }
    } catch (e) {
      setLoading(false);
      setMessageSnack('Ocorreu um erro no processamento da requisição.');
      setTypeSnack('error');
      setShowMessageSnack(true);
    }
  }

  return (
    <div className={classes.root}>
      <UsuarioListChangePassword
        open={openUsuarioChangePassword}
        setOpen={setOpenUsuarioChangePassword}
        usuario={usuarioLogado}
        changePassword={changePassword}
        senhaAtual={senhaAtual}
        setSenhaAtual={setSenhaAtual}
        novaSenha={novaSenha}
        setNovaSenha={setNovaSenha}
        replicaNovaSenha={replicaNovaSenha}
        setReplicaNovaSenha={setReplicaNovaSenha}
        mostrarSenhaAtual={mostrarSenhaAtual}
        setMostrarSenhaAtual={setMostrarSenhaAtual}
        mostrarNovaSenha={mostrarNovaSenha}
        setMostrarNovaSenha={setMostrarNovaSenha}
        mostrarReplicaNovaSenha={mostrarReplicaNovaSenha}
        setMostrarReplicaNovaSenha={setMostrarReplicaNovaSenha}
      />
      <Dialog
        open={openDialogConfirmation}
        onClose={e => closeLogoutConfirmation(e)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirmação"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Tem certeza que deseja realizar sair?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={e => closeLogoutConfirmation(e)} color="primary">
            Cancelar
          </Button>
          <Button onClick={e => logout(e)} color="primary" autoFocus>
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
      <SnackbarCustom
        verticalOrientation='bottom'
        horizontalOrientation='center'
        open={showMessageSnack}
        setOpen={setShowMessageSnack}
        message={messageSnack}
        duration={2000}
        type={typeSnack}
      />
      <ProgressFullScreen
        open={loading}
        setOpen={setLoading}
      />
      <ValidatorForm>
        <Grid
          container
          spacing={4}
        >
          <Grid
            item
            lg={4}
            md={4}
            xl={4}
            xs={12}
          >
            <UsuarioProfileSummarized
              usuario={usuarioLogado}
              setUsuario={setUsuarioLogado}
              openDialogChangePass={openDialogChangePass}
              logout={logoutConfirmation}
              aoModificarImagemPerfil={aoModificarImagemPerfil}
              deletarImagemPerfil={deletarImagemPerfil}
            />
          </Grid>
          <Grid
            item
            lg={8}
            md={8}
            xl={8}
            xs={12}
          >
            <UsuarioProfileDetails
              usuario={usuarioLogado}
              setUsuario={setUsuarioLogado}
              updateUsuario={chamarServiceUpdateUsuario}
              getUsuario={getUsuario}
              setShowMessageSnack={setShowMessageSnack}
              setMessageSnack={setMessageSnack}
              setTypeSnack={setTypeSnack}
            />
          </Grid>
        </Grid>
      </ValidatorForm>

    </div>
  );
};

export default UsuarioProfile;
